import type { AdminPuzzleDto, AdminPuzzleInput } from '@chessx/shared/types'

export const chunkBySize = <T>(items: T[], maxBytes: number): T[][] =>
  items.reduce<{ chunks: T[][]; bytes: number }>(
    ({ chunks, bytes }, item) => {
      const size = JSON.stringify(item).length
      const current = chunks[chunks.length - 1]
      if (current && current.length && bytes + size <= maxBytes) {
        return { chunks: [...chunks.slice(0, -1), [...current, item]], bytes: bytes + size }
      }
      return { chunks: [...chunks, [item]], bytes: size }
    },
    { chunks: [], bytes: 0 }
  ).chunks

export const parseBulkJson = (text: string): unknown[] => {
  const parsed: unknown = JSON.parse(text)
  if (Array.isArray(parsed)) return parsed
  const puzzles = (parsed as { puzzles?: unknown })?.puzzles
  if (Array.isArray(puzzles)) return puzzles
  throw new Error('Expected a JSON array of puzzles or an object with a "puzzles" array')
}

export const toPuzzleInput = ({
  id: _id,
  ownerUserId: _ownerUserId,
  createdAt: _createdAt,
  updatedAt: _updatedAt,
  ...input
}: AdminPuzzleDto): AdminPuzzleInput => input

export const downloadJson = (fileName: string, value: unknown): void => {
  const blob = new Blob([JSON.stringify(value, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}

export const PUZZLE_TEMPLATE: AdminPuzzleInput = {
  puzzleKey: 'lichess:XXXXX',
  source: 'lichess',
  sourceRef: { lichessPuzzleId: 'XXXXX' },
  rating: 1200,
  themes: ['mate', 'mateIn1'],
  goal: 'mate',
  mateIn: 1,
  sideToMove: 'white',
  opponentMove: {
    san: 'a6',
    uci: 'a7a6',
    fenBefore: '6k1/p4ppp/8/8/8/8/5PPP/3R2K1 b - - 0 1',
    intro: { puzzlemaster: '' },
    comment: { puzzlemaster: '' }
  },
  root: {
    fen: '6k1/5ppp/p7/8/8/8/5PPP/3R2K1 w - - 0 2',
    prompt: { puzzlemaster: '' },
    mistakes: [],
    solution: { san: 'Rd8#', uci: 'd1d8', feedback: { puzzlemaster: '' } }
  },
  verdict: { puzzlemaster: '' },
  mistakeDefaults: {},
  gemReward: 10,
  voices: ['puzzlemaster'],
  order: 0,
  isActive: true
}
